import { HttpResponse, http } from 'msw';

import { environment } from '../../environments/environment';

const env = { ...environment };
const module = env.services.urgentAnnouncement;
const envServiceUrl = module.url;

let idCounter = 3;
const items = [
  {
    id: '2',
    content:
      'สมาชิกสมายการ์ดรับสิทธิพิเศษเพิ่มเติม กรุณาประชาสัมพันธ์ลูกค้าให้สมัครสมาชิก ตรวจสอบสื่อประชาสัมพันธ์บริเวณหน้าเคาน์เตอร์และจุดชำระเงินให้พร้อมใช้งาน',
    releaseDate: '2026-07-11',
    releaseTime: '13:00',
    endTime: '16:00',
    status: 'AWAITING_RELEASE',
    createdBy: 'somchai.sa',
    createdByName: 'Somchai Sabaidee',
    createdDate: '2026-07-10T08:00:00'
  },
  {
    id: '1',
    content: 'วันนี้เริ่มแคมเปญ "หอม ถูก ดัง" กรุณาจัดเรียงสินค้าตามแผนผังและตรวจสอบป้ายราคาให้ครบถ้วน',
    releaseDate: '2026-07-09',
    releaseTime: '12:00',
    endTime: '19:00',
    status: 'RELEASED',
    createdBy: 'somchai.sa',
    createdByName: 'Somchai Sabaidee',
    createdDate: '2026-07-09T11:00:00'
  }
];

const sortDesc = list =>
  [...list].sort((a, b) => `${b.releaseDate} ${b.releaseTime}`.localeCompare(`${a.releaseDate} ${a.releaseTime}`));

const getListResolver = ({ request }) => {
  const url = new URL(request.url);
  const page = Number(url.searchParams.get('page') ?? 0);
  const size = Number(url.searchParams.get('size') ?? 20);
  const status = url.searchParams.get('status');

  const filtered = sortDesc(status ? items.filter(item => item.status === status) : items);
  const content = filtered.slice(page * size, (page + 1) * size);

  return HttpResponse.json({
    content,
    totalElements: filtered.length,
    totalPages: Math.ceil(filtered.length / size),
    number: page,
    size
  });
};

const createResolver = async ({ request }) => {
  const payload: any = await request.json();

  const isDuplicate = items.some(
    item =>
      item.status === 'AWAITING_RELEASE' &&
      item.releaseDate === payload.releaseDate &&
      item.releaseTime === payload.releaseTime
  );
  if (isDuplicate) {
    return HttpResponse.json(
      {
        code: 'UA0004',
        message: 'Not allowed to create the Urgent Announcement with a duplicate Release Date and Time.'
      },
      { status: 400 }
    );
  }

  const now = new Date();
  const created = {
    id: String(idCounter++),
    content: payload.content,
    releaseDate: payload.isReleaseNow ? now.toISOString().slice(0, 10) : payload.releaseDate,
    releaseTime: payload.isReleaseNow ? now.toTimeString().slice(0, 5) : payload.releaseTime,
    endTime: payload.endTime,
    status: payload.isReleaseNow ? 'RELEASED' : 'AWAITING_RELEASE',
    createdBy: 'somchai.sa',
    createdByName: 'Somchai Sabaidee',
    createdDate: now.toISOString()
  };
  items.push(created);

  return HttpResponse.json(created);
};

export const handlers = [
  http.get(env.serverUrl + envServiceUrl, getListResolver),
  http.post(env.serverUrl + envServiceUrl, createResolver)
];
